var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuatroIntentos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "74px",
    viewBox: "0 0 69 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.4711002,0 C31.4189204,0 37.4593237,0.215496766 42.0010307,0.582500898 C43.3821579,0.693599376 44.6738641,0.819396716 45.8599238,0.957659524 C46.42338,1.02310323 46.6351523,1.09132569 46.8215109,1.16211916 L46.8437728,1.1706267 C47.0212265,1.23878556 47.1872864,1.3093062 47.6306157,1.38200481 C50.8723223,1.91516323 50.941993,2.56539317 50.941993,3.2670951 L50.941993,3.3089075 C50.9389173,3.99081858 50.8326121,4.62210178 47.6929771,5.1417975 C47.2891632,5.20886639 47.1068754,5.27401455 46.9386,5.33713463 L46.9151898,5.34592891 L46.8918362,5.3546968 C46.685427,5.43202976 46.4709794,5.50626647 45.8599238,5.57720588 C44.6738641,5.71546869 43.3821579,5.84126603 42.0010307,5.95309166 C37.4593237,6.31936864 31.4189204,6.53413825 25.4711002,6.53413825 C19.1535694,6.53413825 13.8479736,6.29220431 9.15546909,5.88245401 C8.08526787,5.78906689 7.07436963,5.68690199 6.13055013,5.57720588 C5.42835936,5.49564228 4.95785577,5.40971981 4.48503412,5.31974403 L4.41224248,5.30586966 C4.1328958,5.25256233 3.84856924,5.19785071 3.51126568,5.1417975 C0.307038113,4.61149574 0,3.96500545 0,3.2670951 C0,2.56539317 0.331764971,1.91516323 3.57367896,1.38200481 C4.49671132,1.23054938 5.0037415,1.08854693 6.13055013,0.957659524 C7.07436963,0.847340139 8.08526787,0.74579852 9.15546909,0.652411394",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 74 68 74 68 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.5133, 67.4659)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13055013,5.57720588 C7.07436963,5.68690199 8.08526787,5.78906689 9.15546909,5.88245401 C13.8479736,6.29220431 19.1535694,6.53413825 25.4711002,6.53413825 C31.4189204,6.53413825 37.4593237,6.31936864 42.0010307,5.95309166 C43.3821579,5.84126603 44.6738641,5.71546869 45.8599238,5.57720588 C47.0128589,5.44335793 46.7538749,5.29777166 47.6929771,5.1417975 C50.8966863,4.61149574 50.941993,3.96500545 50.941993,3.2670951 C50.941993,2.56539317 50.8723223,1.91516323 47.6306157,1.38200481 C46.7070131,1.23054938 46.9868361,1.08854693 45.8599238,0.957659524 C44.6738641,0.819396716 43.3821579,0.693599376 42.0010307,0.582500898 C37.4593237,0.215496766 31.4189204,0 25.4711002,0 C19.1535694,0 13.8479736,0.242661097 9.15546909,0.652411394 C8.08526787,0.74579852 7.07436963,0.847340139 6.13055013,0.957659524 C5.0037415,1.08854693 4.49671132,1.23054938 3.57367896,1.38200481 C0.331764971,1.91516323 0,2.56539317 0,3.2670951 C0,3.96500545 0.307038113,4.61149574 3.51126568,5.1417975 C4.44984952,5.29777166 4.97823707,5.44335793 6.13055013,5.57720588",
    id: "Fill-1",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "6.97639529 70.7329568 60.9918797 70.7329568 60.9918797 61.1619711 6.97639529 61.1619711"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.88779148,72.346154 C5.63602821,72.346154 3,69.7049811 3,66.4469235 L3,6.89928239 C3,3.64117282 5.63602821,1 8.88779148,1 L59.08886,1 C62.3405714,1 64.9765996,3.64117282 64.9765996,6.89928239 L64.9765996,66.4469235 C64.9765996,69.7049811 62.3405714,72.346154 59.08886,72.346154 L8.88779148,72.346154 Z",
    id: "Fill-7",
    fill: "#DF2231"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    points: "0 42.4921319 3.01631381 42.4921319 3.01631381 32 0 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    points: "65 42.4921319 68.0163138 42.4921319 68.0163138 32 65 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#FFFFFF",
    opacity: 0.397670201,
    points: "3 37.7790917 64.998579 37.7790917 64.998579 37 3 37"
  }), /*#__PURE__*/React.createElement("text", {
    id: 4,
    fontFamily: "ArialNarrow-Bold, Arial Narrow",
    fontSize: 58,
    fontWeight: "bold",
    "line-spacing": 27,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.8164062,
    y: 55.6845703
  }, "4"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuatroIntentos);
export default __webpack_public_path__ + "static/media/cuatro-intentos.2234efd4808364e3355b45d8d6992bb7.svg";
export { ForwardRef as ReactComponent };